<template>
  <div>
    <div v-if="isEditable">
      <router-view />
    </div>
    <div v-else>
      <Head
        :keyword="query.keyword"
        :type="query.type"
        :target="query.target"
        @handleQuery="handleQuery"
        @handleRefresh="handleRefresh" />
      <Table
        :tableData="pageData.data"
        :editable="editable"
        @handleRefresh="handleRefresh" />
      <Pagination
        :query="query"
        :pageData="pageData"
        @handleQuery="handleQuery"
        @handleRefresh="handleRefresh" />
    </div>
  </div>
</template>

<script>
import { forIn, has } from 'lodash'
import resStatus from '@/constants/resStatus'
import { pushList } from '@/api/admin/push'
import { adminLogout } from '@/utils/admin'

import Head from './Head'
import Table from './Table'
import Pagination from '@/components/admin/pagination'

export default {
  components: {
    Head,
    Table,
    Pagination,
  },
  data () {
    return {
      query: {
        page: 1,
        pageSize: 10,
        keyword: '',
        type: '',
        target: '',
      },
      editable: true,
      pageData: {
        data: []
      },
      isEditable: false,
    }
  },
  methods: {
    init () {
      const pageName = this.$route.name
      switch (pageName) {
        case 'AdminMemberPushAdd':
        case 'AdminMemberPushEdit':
          this.isEditable = true
          break
        default:
          this.isEditable = false
          pushList(this.query).then(res => {
            switch (res.status) {
              case resStatus.OK:
                this.pageData = res
                break
              default:
                adminLogout()
                this.$message.error(res.message)
            }
          }).catch(err => {
            adminLogout()
            this.$message.error(err)
          })
          break
      }
    },
    handleQuery (obj) {
      forIn(obj, (val, key) => {
        if (has(this.query, key)) {
          this.query[key] = val
        }
      })
    },
    handleEditable (boo) {
      this.editable = boo
    },
    handleRefresh () {
      this.init()
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route (to, from) {
      this.init()
    }
  }
}
</script>
